import { catchError, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { IAppConfig, APP_CONFIG } from '../../../app.config';
import { Observable } from 'rxjs';
import { Payer } from '../../model/payer';

@Injectable()
export class PayerService {
  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    private _progressBar: ProgressBarService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/payer`;
  }

  private readonly _endpoint: string;

  getList(): Observable<Payer[]> {
    return this._client.get<Payer[]>(this._endpoint).pipe(
      map(items => items.map(item => Object.assign(new Payer(), item))),
      catchError(error => {
        this._messageService.showError(error);
        return [];
      })
    );
  }
}
